import React from 'react';
import { Search, Palette, Rocket, Handshake } from 'lucide-react';
import { SectionLabel } from './SectionLabel';
export function Process() {
  const steps = [{
    number: '01',
    icon: Search,
    title: 'Discovery',
    description: 'We learn your business, challenges, and goals through in-depth conversations.'
  }, {
    number: '02',
    icon: Palette,
    title: 'Design & Build',
    description: 'Iterative development with regular check-ins and transparent progress updates.'
  }, {
    number: '03',
    icon: Rocket,
    title: 'Deploy',
    description: 'Launch with comprehensive testing, documentation, and training for your team.'
  }, {
    number: '04',
    icon: Handshake,
    title: 'Long-term partnership',
    description: 'Ongoing support, maintenance, and evolution as your business grows.'
  }];
  return <section className="py-16" data-id="element-132">
      <SectionLabel number="05" label="How we work" data-id="element-133" />
      <h2 className="font-display text-4xl md:text-5xl text-ink mb-10 max-w-2xl leading-[1.05]" data-id="element-134">
        From first call to{' '}
        <span className="italic text-brand-teal" data-id="element-135">long-term partner.</span>
      </h2>
      <div className="grid md:grid-cols-4 gap-6" data-id="element-136">
        {steps.map((step, i) => <div key={step.number} className="relative" data-id="element-137">
            <div className="bg-surface-paper rounded-2xl p-6 border border-ink/10 h-full" data-id="element-138">
              <span className="font-display italic text-4xl text-brand-teal/30 block mb-3" data-id="element-139">
                {step.number}
              </span>
              <step.icon className="w-6 h-6 text-brand-teal mb-4" strokeWidth={1.5} data-id="element-140" />
              <h3 className="text-lg font-bold text-ink mb-2" data-id="element-141">{step.title}</h3>
              <p className="text-sm text-ink-muted leading-relaxed" data-id="element-142">
                {step.description}
              </p>
            </div>
            {i < 3 && <div className="hidden md:block absolute top-1/2 -right-3 w-6 h-0.5 bg-surface-border" data-id="element-143" />}
          </div>)}
      </div>
    </section>;
}